import React from "react";
//Limitless imports
import { log as pilog, ClientContext } from "../../utils";
import { fetchPlatformResources } from "common/apis/resource-api/ResourceAPI";
import { UI_LABELS_JSON } from "../../apis/resource-api/RemoteResourceUtil";
export const LIMITLESS_LOCALE_KEY = "limitless-locale";
const INITIAL_STATE = {
  loading: true,
  failedToLoad: false
};
const getInitialState = (resourceList, defaultContentMap) => {
  let initialState = {
    ...INITIAL_STATE
  };
  resourceList === null || resourceList === void 0 ? void 0 : resourceList.map(resourceItem => {
    const {
      stateKey,
      defaultContent
    } = resourceItem;
    const content = defaultContentMap[stateKey] ? defaultContentMap[stateKey] : defaultContent;
    initialState = {
      ...initialState,
      [stateKey]: content
    };
  });
  return initialState;
};

/**
 * Loads S3 resource from the platform for a given application
 *
 * @param {array} resourceList
 * @param {string} applicationName
 */
export const usePlatformResource = (resourceList, applicationName, defaultContentMap, delayResourcesAPICall = false, previousLocale) => {
  const log = pilog.getLogger("useConfig");
  const [resources, setResources] = React.useState(getInitialState(resourceList, defaultContentMap));
  log.debug(resources);
  React.useEffect(() => {
    if (!delayResourcesAPICall) {
      loadAppResources();
    }
  }, []);
  const setApplicationLanguage = newLocale => {
    if (newLocale !== ClientContext._locale) {
      ClientContext._locale = newLocale;
      //remember the locale for next time
      localStorage.setItem(LIMITLESS_LOCALE_KEY, newLocale);
      loadAppResources(newLocale);
    }
  };
  const loadAppResources = (targetLocale = previousLocale, updatedResourceList = resourceList) => {
    //if previousLocale is null, fetchPlatformResources will use the ClientContext one
    fetchPlatformResources({
      locale: targetLocale,
      resourceList: updatedResourceList,
      applicationName
    }, result => {
      let newState = {};
      updatedResourceList.map(resourceItem => {
        const {
          defaultContent,
          name,
          formatRemoteContent,
          stateKey
        } = resourceItem;
        const platformData = result.find(r => r.resourceName === name);
        if (platformData.content) {
          newState[stateKey] = formatRemoteContent ? formatRemoteContent(platformData.content, defaultContentMap[stateKey]) : platformData.content;
        } else {
          newState[stateKey] = defaultContentMap[stateKey] || defaultContent;
        }
        if (platformData) {
          newState = {
            ...newState
          };
        }
      });
      setResources({
        ...resources,
        ...newState,
        loading: false
      });
    }, () => {
      //error callback
      log.error("Unable to load platform resources, defaults will be used");
      setResources({
        ...resources,
        loading: false,
        failedToLoad: true
      });
    });
  };
  const updateResourceValue = (key, value) => {
    setResources({
      ...resources,
      [key]: value
    });
  };
  const mergeUILabels = newLabels => {
    setResources({
      ...resources,
      [UI_LABELS_JSON.stateKey]: {
        ...resources[UI_LABELS_JSON.stateKey],
        ...newLabels
      }
    });
  };
  const updateUILabels = newLabels => {
    setResources({
      ...resources,
      [UI_LABELS_JSON.stateKey]: newLabels
    });
  };
  return {
    resources,
    loadAppResources,
    updateResourceValue,
    setApplicationLanguage,
    mergeUILabels,
    updateUILabels
  };
};